import { functions } from '@/functions';

export const functions_period = {
    mixins: [functions],
    data: function () {
        return {
            periods: [],
            period: null,
        }
    },

    methods: {

        loadPeriods: function (hotel_id, onSuccess = null, param = null) {
            if (!this.isPeriodsLoaded() && hotel_id) {
                this.periods = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('hotel/' + hotel_id + '/periods/a')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.periods = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetPeriods: function () {
            this.periods = [];
            return this;
        },

        isPeriodsLoaded: function () {
            return (this.periods !== null) && this.periods.length;
        },

        getPeriodTitleById: function (id, periods = null) {
            if (!this.is(id)) {
                return 'не указано';
            }

            if (periods === null) {
                periods = this.periods;
            }

            for (let i = 0; i < periods.length; i++) {
                if (periods[i].id === id) {
                    return periods[i].title;
                }
            }
            return 'period непонятка (#' + id + ')';
        },

        getPeriodById: function (id, periods = null) {
            if (!this.is(id)) {
                return null;
            }

            if (periods === null) {
                periods = this.periods;
            }

            for (let i = 0; i < periods.length; i++) {
                if (periods[i].id === id) {
                    return periods[i];
                }
            }
            return null;
        },

        loadPeriod: function (period_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.get(this.apiurl('period/' + period_id )).then(function (response) {
                response = this.httpSuccess(response);
                this.period = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        enablePeriod: function (period_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('period/' + period_id + '/enable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        disablePeriod: function (period_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('period/' + period_id + '/disable' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        deletePeriod: function (period_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.delete(this.apiurl('period/' + period_id + '/delete' )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        createPeriod: function (hotel_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('period/create/' + hotel_id  )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                this.setLatestPeriod(response.payload.id);
            }, this.httpError)
        },

        clonePeriod: function (period_id, onSuccess = null, param = null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('period/' + period_id + '/clone'  )).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
                this.setLatestPeriod(response.payload.id);
            }, this.httpError)
        },

        delPeriodById: function (id, periods = null) {
            if (!this.is(id)) return false;
            if (periods === null) periods = this.periods;

            for (let i = 0; i < periods.length; i++) {
                if (periods[i].id === id) {
                    periods.splice(i, 1);
                    return true;
                }
            }
            return false;
        },

        savePeriod: function (onSuccess=null, param) {
            this.httpPrepare();
            this.$http.put(this.apiurl('period/'+this.period.id+'/save'), this.period).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                this.setLatestPeriod(this.period.id);
            }, this.httpError)
        },

        latestPeriodClass: function (period) {
            return this.isLatest('App\\Models\\Period', period.id) ? 'latest' : '';
        },
        setLatestPeriod: function (id) {
            this.setLatest('App\\Models\\Period', id);
        },

    }
};
